import { apiUrl, authFetch } from "./api";

export type PdfHeaderData = {
  name?: string;
  address?: string;
  street?: string;
  zip_city?: string;
  phone?: string;
  ik?: string;
  logoUrl?: string | null;
};

export const PDF_FOOTER_TEXT = "QM Sonne - Digitales Qualitätsmanagement für die Pflege.";

const escapeHtml = (value: string) =>
  value.replace(/[&<>'"]/g, (ch) => {
    switch (ch) {
      case "&":
        return "&amp;";
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "'":
        return "&#39;";
      case '"':
        return "&quot;";
      default:
        return ch;
    }
  });

export function getPdfHeaderLines(data?: PdfHeaderData | null): string[] {
  if (!data) return [];
  const rawAddress = data.address || [data.street, data.zip_city].filter(Boolean).join(" ");
  const address = rawAddress.replace(/\s*\n\s*/g, " ").trim();
  const lines = [
    data.name || "",
    address,
    data.phone ? `Telefon: ${data.phone}` : "",
    data.ik ? `IK: ${data.ik}` : "",
  ].filter(Boolean);
  return lines;
}

export function buildPdfHeaderHtml(data?: PdfHeaderData | null): string {
  const lines = getPdfHeaderLines(data);
  const left = lines.map((line) => `<div>${escapeHtml(line)}</div>`).join("");
  const right = data?.logoUrl ? `<img src="${escapeHtml(data.logoUrl)}" alt="Logo" />` : "";
  return `<div class="doc-header"><div class="doc-header-left">${left}</div><div class="doc-header-right">${right}</div></div>`;
}

export function buildPdfFooterHtml(): string {
  return `<div class="doc-footer">${escapeHtml(PDF_FOOTER_TEXT)}</div>`;
}

export const PDF_HEADER_CSS = `
  .doc-header { position: fixed; top: 12px; left: 24px; right: 24px; display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
  .doc-header-left { font-size: 11px; line-height: 1.35; color: #0f172a; min-height: 48px; }
  .doc-header-right img { max-height: 48px; max-width: 160px; object-fit: contain; }
  .doc-footer { position: fixed; bottom: 12px; left: 24px; right: 24px; text-align: center; font-size: 10px; color: #64748b; }
`;

export async function loadPdfHeaderData(
  businessId?: string | number | null
): Promise<PdfHeaderData | null> {
  if (!businessId) return null;
  try {
    const resp = await authFetch(apiUrl(`/api/v1/businesses/${businessId}`));
    if (!resp.ok) return null;
    const data = await resp.json();
    return {
      name: data.name || "",
      address: data.address || "",
      street: data.street || "",
      zip_city: data.zip_city || "",
      phone: data.contact_phone || "",
      ik: data.ik || "",
      logoUrl: data.logo_url || null,
    };
  } catch {
    return null;
  }
}
